import { StatisticsByCustomerThreeYearsStatisticsDetailsQuery } from "@/gql/graphql";
import { Card, CardBody, CardHeader } from "@stenajs-webui/elements";
import { StandardTable } from "@stenajs-webui/grid";
import * as React from "react";
import { threeYearsTargetActualTableConfig } from "../config/ThreeYearsTargetActualTableConfig";
import { transformThreeYearsTargetAndActualToTableRows } from "../lib/transformers/customer-table.transformer";

interface Props {
  year: number;
  threeYearsTargetAndActual: StatisticsByCustomerThreeYearsStatisticsDetailsQuery["statistics"]["customerDetails"]["threeYearsTargetAndActualByCustNoAndYear"];
  loading: boolean;
}

export const ThreeYearsTargetActualTable: React.FC<Props> = ({
  year,
  threeYearsTargetAndActual,
  loading,
}) => {
  return (
    <>
      <Card width={"100%"}>
        <CardHeader text={"Target/Actual"} />
        <CardBody>
          <StandardTable
            items={transformThreeYearsTargetAndActualToTableRows(
              threeYearsTargetAndActual,
              year
            ).sort((a, b) => a.routePairCode.localeCompare(b.routePairCode))}
            loading={loading}
            config={threeYearsTargetActualTableConfig(year)}
          />
        </CardBody>
      </Card>
    </>
  );
};
